import { render, staticRenderFns } from "./AgencyCongratesDialog.vue?vue&type=template&id=c06309ec&scoped=true"
import script from "./AgencyCongratesDialog.vue?vue&type=script&lang=js"
export * from "./AgencyCongratesDialog.vue?vue&type=script&lang=js"
import style0 from "./AgencyCongratesDialog.vue?vue&type=style&index=0&id=c06309ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06309ec",
  null
  
)

export default component.exports